import { CalendarDaysIcon, EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/outline';
import { ProUpgradeDialog, type ProUpgradeUseCase } from '~/components/pro-upgrade-dialog';

const TRIGGERS_PRO_UPGRADE_USE_CASES: ProUpgradeUseCase[] = [
  {
    id: 'email',
    title: 'Automate incoming email',
    description:
      'Forward or BCC email to a dedicated Cara alias and automatically run the right preset with its attachments.',
    icon: (
      <div className="inline-flex rounded bg-sky-100 dark:bg-sky-500/20 p-2 text-sky-700 dark:text-sky-300">
        <EnvelopeIcon className="size-4" />
      </div>
    )
  },
  {
    id: 'schedule',
    title: 'Run recurring work',
    description:
      'Launch a preset on selected days and times for recurring reviews, summaries, and follow-up.',
    icon: (
      <div className="inline-flex rounded bg-blue-100 dark:bg-blue-500/20 p-2 text-blue-700 dark:text-blue-300">
        <CalendarDaysIcon className="size-4" />
      </div>
    )
  },
  {
    id: 'call',
    title: 'Follow up after calls',
    description:
      'Run a preset after a qualifying call completes while keeping simple notifications in Voice settings.',
    icon: (
      <div className="inline-flex rounded bg-purple-100 dark:bg-purple-500/20 p-2 text-purple-700 dark:text-purple-300">
        <PhoneIcon className="size-4" />
      </div>
    )
  }
];

export const TriggersProUpgradeDialog = (props: { open: boolean; onClose: () => void }) => (
  <ProUpgradeDialog
    open={props.open}
    onClose={props.onClose}
    title="Unlock Triggers with Pro"
    description="Automatically launch Cara presets from incoming email, scheduled times, and completed calls. Upgrade to Pro to configure and manage triggers."
    useCases={TRIGGERS_PRO_UPGRADE_USE_CASES}
  />
);
